// MisCambiosPage.tsx
import { CambiosPage } from "../cambio-service-page/CambioServicePage";
import { useAuthStore } from "@/store/auth/auth.store"; 
import { useUserModulesStore } from "@/store/auth";       
import { SystemModulesEnum } from "@/auth/interfaces";
import { Outlet } from "react-router-dom";
export default function MisCambiosPage() {
  const user = useAuthStore((s) => s.user) as any; 
  const userModules = useUserModulesStore((s) => s.modules);  
  const isSuper = !!user?.is_superuser || !!user?.is_staff; 
  const tineAccesoAreacontrolAreas = userModules.includes(SystemModulesEnum.CONTROL_CAMBIOS_MIS_APROBACIONES) 

  if(!isSuper || !tineAccesoAreacontrolAreas){
   return <CambiosPage soloMios />;
    }
         return <Outlet />;
}
